import * as React from "react";
import Header from "../Header";
import Footer from "../Footer";
import { ISetUrl } from "../../AppMain";
import { Lng } from "../../../languages/Languages";
import { Api } from "../../lib/Api";
import ActiveOrders from "./ActiveOrders";
import {TStorage} from "../../../avernus/tstorage/TStorage";
import FilterForm from "../header/FilterForm";
import OfferListTitle from "./OfferListTitle";
import LoaderComp from "../../../avernus/loader/source/LoaderComp";

interface IUserIndexProps {
    setUrl:ISetUrl
}

interface IUserMenu{
    className: string
    icon     : string
    iconAlign: 'left'|'top'
    url      : string
    title    : string
}

interface IUserIndexState {
    className: string
    items    : IUserMenu[]
}

export default class UserIndex extends React.Component<IUserIndexProps, IUserIndexState>{

    private menus:Array<IUserIndexState>;

    constructor(props:IUserIndexProps){
        super(props);
        this.menus = [
            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/users/icons/professional_nearme_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'Professionals near me',
                    url      : '/user/offers/'
                }]
            },
            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/users/icons/map_search_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'Map\n' + 'Search',
                    url      : '/user/map-search/'
                }]
            },

            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/users/icons/favorite_professional_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'My favorite\n' + 'Professionals',
                    url      : '/user/favourite-restaurants/'
                }]
            },
            {
                className: 'col-6',
                items    : [{
                    icon     : 'img/users/icons/previous_assignments_icon.png',
                    className: '',
                    iconAlign: 'top',
                    title    : 'Previous\n' + 'Assignments',
                    url     : '#'
                   // url      : '/restaurant/financial-statement/'
                }]
            },

        ];
    }

    private clickHandler(evt, url:string): void {
        evt.preventDefault();
        this.props.setUrl(url);
    }

    private filterChangedHandler(str): void {
        this.props.setUrl('/user/offers/', {
            filter: str
        });
    }

    render() {
        return (
            <div className = "user_index">
                <Header
                    setUrl={this.props.setUrl}
                    showSearchForm={true}
                    getActiveOrders={Api.isFrontUser()}
                    userWelcome={true}
                />
                <section className="content_section container dashboard">
                    <div className = "welcome-block">
                        <p className = "user-name">Hi {new TStorage().get('name', '')},</p>
                        <p className = "block-title">
                            how can we help you?
                        </p>
                    </div>

                    <FilterForm changed={str => this.filterChangedHandler(str)} />



                    <section className="dashboard_menu">
                        <div className="row">
                            <div className = "col-md-12">
                                <ActiveOrders setUrl = {(url, data) => this.props.setUrl(url, data)} />
                            </div>

                            {this.menus.map((menu, index) =>{

                                return(
                                    <div className={menu.className}>
                                        {menu.items.map((item?) => {
                                            let className = item.className+' text-center box_align_'+item.iconAlign;
                                            return(
                                                <div className={className} key={index+'_'}>
                                                    <a onClick={ (e) => { this.clickHandler(e, item.url); } } className={item.url===''?'disabled':''}>
                                                    <span>
                                                        <div className="icon_container">
                                                            <img src={item.icon} alt="" />
                                                        </div>
                                                        <div className = "label">
                                                            { item.title }
                                                        </div>
                                                    </span>
                                                    </a>
                                                </div>
                                            )

                                        })}
                                    </div>

                                )

                            })}
                        </div>
                    </section>
                </section>
                <Footer homePageMode={Api.isFrontUser()} setUrl={this.props.setUrl}></Footer>
			</div>
        );
    }
}
